import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import ConfirmButton from '../../../../components/confirm-button';

class ActionCellRenderer extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { data, deleting } = this.props;
    if (!data) {
      return null;
    }
    return (
      <ConfirmButton
        disabled={deleting}
        size="xs"
        onConfirm={() => {
          this.props.requestDelete(data);
        }}
      >
        <Fa name="trash" /> Delete
      </ConfirmButton>
    );
  }
}

ActionCellRenderer.propTypes = {
  requestDelete: PropTypes.func,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
  deleting: PropTypes.bool,
};
ActionCellRenderer.defaultProps = {
  requestDelete: () => {},
  data: null,
  deleting: false,
};


export default ActionCellRenderer;
